const KonfigTracking = (() => {

  // ── KONFIGURATION ─────────────────────────────────────────
  const WP_URL  = 'https://dashboard.mirrored.pro/';
  const API_KEY = 'testkey';
  const KONFIG  = 'Portable: eZ Cinema TT'; // ← pro Kunde anpassen
  const USER_ID = 5;            // ← WP User ID des Kunden

  // ── SESSION STATE ─────────────────────────────────────────
  const SESSION_ID    = 'sess-' + Math.random().toString(36).substr(2, 9);
  const SESSION_START = { time: null };
  let   _endFired     = false; // doppeltes Feuern verhindern

  // ── DEVICE ────────────────────────────────────────────────
  function getDevice() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
  }

  // ── SEND ──────────────────────────────────────────────────
  function send(element_key, event_type, duration_ms = 0, cart_value = 0) {
    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key,
      event_type,
      duration_ms,
      cart_value,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon wenn fetch fehlschlägt
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── END SESSION ───────────────────────────────────────────
  function endSession() {
    // Doppeltes Feuern verhindern
    if (!SESSION_START.time || _endFired) return;
    _endFired = true;

    const duration_ms = Date.now() - SESSION_START.time;
    SESSION_START.time = null;

    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key:  'session:close',
      event_type:   'dwell',
      duration_ms:  duration_ms,
      cart_value:   0,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  function init() {
    SESSION_START.time = Date.now();
    _endFired          = false; // Reset falls init() erneut aufgerufen wird
    send('session:start', 'click');

    // Methode 1: Tab/Browser schließen, URL wechseln
    window.addEventListener('beforeunload', endSession, { once: true });

    // Methode 2: Tab wechseln, App minimieren (iOS zuverlässig)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        endSession();
      }
    }, { once: true });
  }

  // ── TRACK CLICK ───────────────────────────────────────────
  function track(category, value, cartValue = 0) {
    const element_key = ['addcart','failedcart', 'ar:start', 'session:close'].includes(category)
      ? category
      : `${category}:${value}`;
    send(element_key, 'click', 0, cartValue);
  }

  // ── TRACK DWELL ───────────────────────────────────────────
  function trackDwell(category, value, startTime) {
    const ms = Date.now() - startTime;
    if (ms < 500) return; // unter 0.5s ignorieren
    send(`${category}:${value}`, 'dwell', ms);
  }

  // ── EXPORT ────────────────────────────────────────────────
  return { init, track, trackDwell, endSession };

})();


const Base = {
  "projectorTypes": {
    "Standard-Throw": {
      "Dark": {
        "Cinegrey": {
          "r169": {
            "White":{
              "113": [
                { "30": ["45071153955082"] }],
              "121": [
                { "30": ["45071153987850"] } ],
            },
          },
        }
      }
    },
     "Short-Throw": {
      "Dark": {
        "CLR": {
          "r169": {
            "White":{
              "103": [
                { "30": ["52208974332170"] }],
              "113": [
                { "30": ["52208963748106"] } ],
                  "123": [
                { "30": ["52208963780874"] } ]
            },
          },
        }
      },
       "Bright": {
        "CLR": {
          "r169": {
            "White":{
              "103": [
                { "30": ["52208974332170"] }],
              "113": [
                { "30": ["52208963748106"] } ],
                  "123": [
                { "30": ["52208963780874"] } ]
            },
          },
        }
      }
      
    }
  },

  
};


var selection={
    "Beamer":'Short-Throw',
    "Ambience":'Dark',
    "Material":'CLR',
    "Aspect":'r169',
    "CaseColor":'White',
    "Size":100,
    "TopDrop":30,
    "ProdVariant":"52208974332170",
}

//// Babylon Render Engine 
var slider = document.getElementById("myRange");
var slider2 = document.getElementById("myRange2");

       

        var roomnotice = document.getElementById("notice");
        var slidercol3 = document.getElementById("sliderfiller3");


/*var output = document.getElementById("demo");
output.innerHTML = slider.value; // Display the default slider value
*/
var price = 99900;  
 var sliderWidth;
    var labelWidth;
    var newLeft;

var values169;
var values1610;

var leinwandmesh;
//var shebeammesh;
//var shbeammermesh;

var scalefactorX =1;
var scalefactorY =1;
var zfactor= 0.49;
var vfactor= 61.5;
var avMaterials;
    const button3d = document.getElementById("3db");

if (button3d) {
  button3d.addEventListener("click", showOnly);
}
          
                  document.getElementById("close").addEventListener("click", closeModal);

      const sections = document.querySelectorAll('section');
 var sections1 = document.getElementsByClassName("shopify-section");

  $('.togglebutton').click(function() {
  const $btn = $(this);
  const $panel = $btn.next('.panel'); // nächstes Geschwister-Element
   
  $panel.toggleClass('closed'); // Panel ein-/ausfahren
  $btn.find('.chevron').toggleClass('rotate'); // Chevron drehen
});


function showOnly() {

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="none";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = 'none';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-"+tpn);
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="block";
  }

  //newParent.appendChild(priceTags);
  KonfigTracking.init();
  startRender();
engine.resize();
  

       //startRender();
         window.scrollTo({
        top: 0,
        behavior: "smooth" // smooth scroll, optional
    });

}

        function closeModal() {
   KonfigTracking.endSession();

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = '';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-"+tpn);
  if (selectedDiv) {
    selectedDiv.style.display = 'none'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="none";
  }
          //oldParent.appendChild(priceTags);
        }
      


/*
  // Alle Elemente im body auswählen
  const allDivs = document.querySelectorAll('body > *');

  allDivs.forEach(div => {
    if (div.id !== '3dconfig') {
      div.style.display = 'none'; // Alle ausblenden, außer das mit der ID '3dconfig'
    }
  });

  // Das gewählte Div einblenden
  const selectedDiv = document.getElementById("3dconfig");
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div einblenden
  }*/


  



const canvas = document.getElementById("renderCanvas"); // Get the canvas element
      const engine = new BABYLON.Engine(canvas, true); // Generate the BABYLON 3D engine

engine.setHardwareScalingLevel(1 / window.devicePixelRatio);

      // Add your code here matching the playground format
      const createScene = function () {
        const scene = new BABYLON.Scene(engine);

      const empty = new BABYLON.TransformNode("emptyParent", scene);
      //  empty.position.y=0;
        empty.rotation=new BABYLON.Vector3(0,0,0)
        //empty.rotation = BABYLON.Vector3.Zero();




       
        //const hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("https://assets.babylonjs.com/environments/environmentSpecular.env", scene);
        //scene.environmentTexture = hdrTexture;
        var standardbeambool = false;
        var shortbeambool = false;

        function sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
   
         values169 = [103,113,123];


        var topDrops=[30];

        var tdVal2 = 11.5;  //die gesamtgröße zu beginn, also tB TD:30cm in zoll sind 11.81 ( + unterer Bastand von 3,5 cm = 33,4cm in zoll sind 13.77) 
        var oldInd=100;
        var newInd=100;

        var nextpos;

        let debounceTimeout;
      
        
        const sliderValue = document.getElementById('sliderLabel');
        const sliderValue2 = document.getElementById('sliderLabel2');

     
        var tdVal = 13.77;
        var tDheight;
       
        var oldTD = 30;



   
        var tdVal4;
        var tDheight4;
        var nearestTopDrop = 15;

      
       /* 
        var td10 = document.getElementById("td10");
        var td15 = document.getElementById("td15");
        var td25 = document.getElementById("td25");
        var td30 = document.getElementById("td30");
        var td50 = document.getElementById("td50");
        var td60 = document.getElementById("td60");

        td10.addEventListener("click", buttonTD);
        td15.addEventListener("click", buttonTD);
        td25.addEventListener("click", buttonTD);
        td30.addEventListener("click", buttonTD);
        td50.addEventListener("click", buttonTD);
        td60.addEventListener("click", buttonTD);
*/


        function buttonTD(){
          nearestTopDrop = $(this).attr("value");
        //console.log(nearestTopDrop);

        //$("#tdDiv button").prop('disabled', false);
        //$(this).prop('disabled', true);

        $("#tdDiv button").css({
          "background-color": "white",
          "border": "solid 1px grey"
         
        });

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
        })

        scaletoTD();

        
        }
var titleRecap;

 document.getElementById("Standard-Throw").addEventListener("click",selectStandardBeamer);

       function selectStandardBeamer(){
        //console.log("NewInd:"+ newInd+"oldInd: "+ oldInd);
        selection.Beamer= $(this).attr("id");
        
KonfigTracking.track('Beamer', 'Standard');

        //const event = new Event("click", { bubbles: true, cancelable: true });
       // document.getElementById("MaxWhite").dispatchEvent(event);

        $("#Standard-Throw").prop('disabled', true);
        $("#Short-Throw").prop('disabled', false);
        
        $("#Short-Throw").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        
      if(selection.Beamer=="Standard-Throw"&&selection.Ambience=="Dark"){
         $("#Bright").css({
          "background-color": "grey",
          "cursor": "not-allowed",
      });

      $("#Bright").prop('disabled', true);
      }else{

            $("#Bright").css({
          "background-color": "white",
          "cursor": "",
      });

      $("#Bright").prop('disabled', false);
      }
        
    //    //console.log(selection.Beamer);
        getMaterials();

         const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);

        
      /*  if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        }
*/
        standardbeambool = true;
        shortbeambool = false;

       /* stbeam = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "beam22.glb", scene, function(newMeshes){
          stbeammesh= newMeshes[1];
           camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
           camera.setTarget(new BABYLON.Vector3(0, -1,2));
         
       

          stbeammesh.scaling = new BABYLON.Vector3(newInd/100,newInd/100,1);

          stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
          //console.log("Y KOORD:"+stbeammesh.position.y); 
          
       });

       stbeamer = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "standardBeamer-v1.glb", scene, function(newMeshes){
        stbeamermesh= newMeshes[0];
         //camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
         //camera.setTarget(new BABYLON.Vector3(0, -1,2));
        //stbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(newInd/99)),0.05);
        stbeamermesh.position.y= -0.5;
       //console.log("Y_POS "+stbeamermesh.position.y);
        
     });
*/

       }


         document.getElementById("Short-Throw").addEventListener("click",selectShortBeamer);

       function selectShortBeamer(){

    KonfigTracking.track('Beamer', 'Short');

            shortbeambool = true;
          standardbeambool = false;
        
        /*shbeamer = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "shortBeamer-v2.glb", scene, function(newMeshes){
        shbeamermesh= newMeshes[0];
        //camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
         //camera.setTarget(new BABYLON.Vector3(0, -1,2));
        shbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(newInd/99)),0.05);
        
        
        }); */
        
          console.log("NewInd:"+ newInd+"oldInd: "+ oldInd);

       
          selection.Aspect= "r169";

        selection.Beamer= $(this).attr("id");
        selection.Material= "CLR";
    

        $("#Standard-Throw").prop('disabled', false);
        $("#Short-Throw").prop('disabled', true);

       
        $("#Standard-Throw").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });


   
        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

      //     const event = new Event("click", { bubbles: true, cancelable: true });
      //  document.getElementById("CLR").dispatchEvent(event);
        

         if(selection.Beamer=="Standard-Throw"&&selection.Ambience=="Dark"){
         $("#Bright").css({
          "background-color": "grey",
          "cursor": "not-allowed",
      });

      $("#Bright").prop('disabled', true);
      }else{

            $("#Bright").css({
          "background-color": "white",
          "cursor": "",
      });

      $("#Bright").prop('disabled', false);
      }


     //   console.log(selection.Beamer);
     getMaterials();

      const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);

     //getColor();
     //getSizes();
     //setTD(); //12.05    
     /*topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
     setTD();
     scaletoTD();*/

       //scale169();

      /*  if(standardbeambool){
          stbeamermesh.dispose();
        stbeammesh.dispose();
        }*/
        

        
      
  console.log(newInd);
     
   

      }

      function getMaterials(){
    
   // BEFORE AMB. 
   // var avMaterials = Object.keys(Base.projectorTypes[selection.Beamer].materials);
   console.log(Base.projectorTypes[selection.Beamer]);
   console.log(Base.projectorTypes["Standard-Throw"]);
     console.log(Base.projectorTypes["Standard-Throw"]["Dark"]);
     console.log(selection);

    avMaterials = Object.keys(Base.projectorTypes[selection["Beamer"]][selection["Ambience"]]);
    console.log(avMaterials);

    // Alle verfügbaren Materialien angeben!
    hideUI();


   

// Schleife durch die verfügbaren Materialien
for (const button of buttons) {
  if (avMaterials.includes(button)) {
    const el = document.getElementById(button);
    if (el) {
      el.style.display = "inline-flex"; // Anzeigen
    }
  }
} 


}
      

function hideUI(){
 document.querySelectorAll(".buttonMat").forEach(btn => {
  btn.style.display = "none";
});
}

        function getPrice(){

            
          //console.log("GETPRICE");
          var currentId= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][selection.Size].find(item => item[selection.TopDrop])?.[selection.TopDrop][0];
          console.log(currentId);
          selection.ProdVariant=currentId;
            price = getPriceById(meta, Number(currentId));
                //console.log(titleRecap);
            //console.log(price);
       var   formattedPrice = (price / 100).toLocaleString("de-DE", { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
});
   
         //console.log(formattedPrice);
         pricehtml.innerHTML = "€"+String(formattedPrice)+" EUR";
         confightml.innerHTML= String(titleRecap);
         
checkVariantAvailability(selection.ProdVariant);    
        }
        
        function getPriceById(product, variantId) {
    const variant = product.product.variants.find(v => v.id === variantId);
          titleRecap = variant.public_title
    return variant ? variant.price : null; 
}

   

       var pricehtml = document.getElementById( "pricehtml");
        var confightml = document.getElementById( "confightml");
        


       async function scaletoTD(){
        
        ////console.log(oldTD+nearestTopDrop);
       selection.TopDrop = nearestTopDrop;

         var tdVal3;
              var tDheight3;
       
              //getPrice();
         
        //console.log("old "+oldTD+"nearest "+ nearestTopDrop+"oldInd+ "+oldInd);
        

        if(selection.Aspect =="r169"){
          ////console.log("oldTD"+ oldTD + "new TD "+nearestTopDrop );
          if(oldTD <= nearestTopDrop){
            //console.log("smaller than");
            
            for(let i=oldTD; i< nearestTopDrop;i++){
              //console.log(i);
              tdVal3 = ((i)/2.54)+(7/2.54);
              tDheight3=(oldInd*0.49);     
                 
              leinwandmesh.scaling = new BABYLON.Vector3(newInd/100,((tDheight3+tdVal3)/(65)),1);
               //leinwandmesh.rotation = new BABYLON.Vector3(0,Math.PI,0);
                 
    
              //console.log("height "+tDheight3);
                //console.log("tdval "+tdVal3);
              
             //console.log((tDheight3+tdVal3)/(53.93));
              
         

               await sleep(20); 
            }
            

          }

          if(oldTD > nearestTopDrop){
            //console.log("bigger");
            for(let i=oldTD; i> nearestTopDrop;i--){
            //console.log(i);
              tdVal3 = ((i)/2.54)+(7/2.54);
               tDheight3=(oldInd*0.49);        
              leinwandmesh.scaling = new BABYLON.Vector3(newInd/100,(tDheight3+tdVal3)/(65),1);
                  //leinwandmesh.rotation = new BABYLON.Vector3(0,Math.PI,0);
          

              
              //console.log((tDheight3+tdVal3)/(53.93));
              


              /*
              if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              }
              if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              }*/

              await sleep(20); 
            }

          }

  
        }



         if(selection.Aspect=="r43"){

          //(newInd*0.00972,(tDheight+tdVal)/(66),
       
          ////console.log("oldTD"+ oldTD + "new TD "+nearestTopDrop );
          if(oldTD <= nearestTopDrop){
            for(let i=oldTD; i< nearestTopDrop;i++){

              tdVal4 = ((i)/2.54);
              tDheight4=(oldInd*0.6); // hier wird der TD nochmal ausgerechnet aber im verhältnis 16:10
           
             
             // leinwandmesh.scaling = new BABYLON.Vector3((newInd/84),(tDheight4+tdVal4)/(66),1);

               leinwandmesh.scaling = new BABYLON.Vector3(scalefactorX*(newInd/100),scalefactorY*(tDheight4+tdVal4)/(70.22),1);
         

              
              /*

              if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              }
              if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              } */
               await sleep(20); 
            }

          }

          if(oldTD >= nearestTopDrop){
            for(let i=oldTD; i> nearestTopDrop;i--){
          tdVal4 = ((i)/2.54);
              tDheight4=(oldInd*0.6); // hier wird der TD nochmal ausgerechnet aber im verhältnis 16:10
           
             
             // leinwandmesh.scaling = new BABYLON.Vector3((newInd/84),(tDheight4+tdVal4)/(66),1);

               leinwandmesh.scaling = new BABYLON.Vector3(scalefactorX*(newInd/100),scalefactorY*(tDheight4+tdVal4)/(70.22),1);
        

              
              /*

              if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              }
              if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              } */
               await sleep(20); 
              
            }

          }

        }

           tdVal=parseFloat((Number((nearestTopDrop)/2.54)).toFixed(2));
          tdVal2 = parseFloat(((Number(nearestTopDrop)) / 2.54));
          oldTD=nearestTopDrop;
          console.log("TDVAL 2 "+tdVal2);
     getPrice();
        
  
      
      }

        var nearestTopDrop;

       

        /*function setTD(){
          var tdsliderVal = tDslider.value;
         // //console.log("tdslider "+ tdsliderVal);
          tDslider.min=topDrops[0];
          tDslider.max=topDrops[topDrops.length - 1 ]; 
         
           nearestTopDrop= _.minBy(topDrops, (value) => Math.abs(value - tdsliderVal));

          tDslider.value=nearestTopDrop;
          tDLabel.innerHTML=tDslider.value;
          ////console.log("nearest topdrtop: "+nearestTopDrop);

          const tDsliderWidth = tDslider.offsetWidth;
          const tDlabelWidth = tDLabel.offsetWidth;
          const tDnewLeft = ((nearestTopDrop -  tDslider.min) / (tDslider.max -  tDslider.min)) * tDsliderWidth - (tDlabelWidth / 2);
          tDLabel.style.left = `${tDnewLeft}px`;
  

        }
      */

         function setTD(){
           
   $("#tdDiv button").css({
            "background-color": "white",
            "border": "solid 1px grey",
            "display":"none"
          });


       
           
          if (topDrops.includes(String(selection.TopDrop))){
            //console.log("ist hte same");
               for (let i = 0; i < topDrops.length; i++) {
            document.getElementById("td"+topDrops[i]).style.display = "inline-block";
              
        }
 //document.getElementById("td"+String(selection.TopDrop)).style.border = "solid 2px #0056f3";
        //getPrice();
         setTimeout(() => {
         
           
 $('#tdDiv button:visible').first().trigger('click');
}, "400"); 
             
          }else{
            //console.log("not the same");
            for (let i = 0; i < topDrops.length; i++) {
                         

            if(i===0){
              document.getElementById("td"+topDrops[0]).style.border = "solid 1px black";
            }
            document.getElementById("td"+topDrops[i]).style.display = "inline-block";
        }
            setTimeout(() => {
         
           
 $('#tdDiv button:visible').first().trigger('click');
}, "400");   

          }
        
        
        }

         



           
            

        const colors = ['White', 'Black'];

        

                const tickContainer = document.querySelector('.slider-ticks');


      function getSizes(){


        tickContainer.innerHTML = "";
        
        var avSizes = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
        //console.log(selection);
        //console.log("avSizes: "+avSizes);
        values169= avSizes;
      
       //slider2 = document.getElementById("myRange2");
       slider2.min=avSizes[0];
       slider2.max=avSizes[avSizes.length - 1 ]; 

        
       avSizes.forEach(val => {
  const span = document.createElement('span');
  span.textContent = "'";

  // Position in Pixeln berechnen
  const ratio = (val -  slider2.min) / (slider2.max -  slider2.min);
  const posPx = ratio * 346;

  
  span.style.left = `${posPx}px`;

  if(ratio==0){
    span.style.left = `5px`;
  }

  tickContainer.appendChild(span);
});
  

        
       const nearestValue = _.minBy(values169, (value) => Math.abs(value - oldInd));
        
       //topDrops = Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][nearestValue];
        ////console.log(topDrops);

       slider2.value=nearestValue;
       sliderValue.innerHTML=nearestValue;
       selection.Size = nearestValue;


       //oldInd=newInd;
      newInd = Number(nearestValue);
       
        //slider2.dispatchEvent(new Event('input'));

        overallScale();

      sliderWidth = slider2.offsetWidth;  // Breite des Sliders
     labelWidth = sliderValue.offsetWidth; // Breite des Labels
     newLeft = ((slider2.value - slider2.min) / (slider2.max - slider2.min)) * sliderWidth - (labelWidth / 2);

sliderValue.style.left = `${newLeft}px`;
  if(newLeft<=0){
         slidercol.style.width="10px"
sliderValue.style.left = `-4px`;
         }else{
          slidercol.style.width=`${newLeft}px`;
         }
        
    
      }




  



              
                
              
            


            document.getElementById("r169").addEventListener("click", changeScale169 );

              function changeScale169(){

                      leinwandmesh.rotation = new BABYLON.Vector3(0,0,0);
              
                 
                         

              selection.Aspect="r169";

              $("#r169").prop('disabled', true);
           
              $("#r43").prop('disabled', false);

            
                 $("#r43").css({
                "background-color": "",
                "border-color": "",
                "border-width": ""
            });
                    $("#r169").css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });
            

              //newInd=100; 12.5
              //selection.Size=100; 12.5 

              getSizes();
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
        // //console.log("topDrops "+ topDrops);
         // setTD();

     


              
              
              //getColor();

 scalefactorX =1;
 scalefactorY =1;
 zfactor= 0.49;

              //newInd= 100; 
               //setTD();

               overallScale(); 

                //setTD();

             setTimeout(() => {
    setTD();
    //console.log("Beide Funktionen wurden aufgerufen.");
}, 1000); 
                
              }
  




              async function overallScale(){
                   // //console.log("scale169: " +"oldInd:"+oldInd+"newInd: "+newInd);

              
              
              // FORMEL FÜR DIE HÖHE IST ((i*0.49) + 13.77) / (62.77)

              // NEUE GRÖße IN DIAGONAL IN ZOLL * VERHÄLTNISFAKTOR + TOPDROP IN ZOLL / GESAMTHÖHE DER LW IN ZOLL (49+13,77)
             // //console.log("inside scale");
              //getColor();
             // //console.log("olidn: "+oldInd+"newind: "+ newInd);
             if(oldInd <= newInd){
              for (let i = oldInd; i <= newInd; i++) {   
        
                   gehäusemesh.scaling = new BABYLON.Vector3(scalefactorX*(i/100),1,1);
          leinwandmesh.scaling = new BABYLON.Vector3 (scalefactorX*(i/100),((i*zfactor) + tdVal2) / (vfactor),1);
          leinwandtuch.scaling = new BABYLON.Vector3(scalefactorX*(i/100),1,scalefactorY*(i/100)); 
          logomesh.position = new BABYLON.Vector3(scalefactorX*((i-100)*0.0118),0,0);

              leinwandmesh.rotation = new BABYLON.Vector3(0,0,0);
              
                gehäusemesh.rotation = new BABYLON.Vector3(Math.PI/3,0,0);

                 
 
                  
            }}else if(oldInd > newInd){
              ////console.log("inside for o>n");   
              ////console.log("tdVAL: "+tdVal);
              for (let i = oldInd; i > newInd; i--) {      

                   gehäusemesh.scaling = new BABYLON.Vector3(scalefactorX*(i/100),1,1);
          leinwandmesh.scaling = new BABYLON.Vector3 (scalefactorX*(i/100),((i*zfactor) + tdVal2) / (vfactor),1);
          leinwandtuch.scaling = new BABYLON.Vector3(scalefactorX*(i/100),1,scalefactorY*(i/100)); 
          logomesh.position = new BABYLON.Vector3(scalefactorX*((i-100)*0.0118),0,0);

              leinwandmesh.rotation = new BABYLON.Vector3(0,0,0);
              
              gehäusemesh.rotation = new BABYLON.Vector3(Math.PI/3,0,0);

                 
 
            //console.log(scalefactorY*(i/84));


              
                
                      await sleep(30);          
            }

           
            }
       
            //getPrice();

            oldInd=newInd;
            ////console.log("post scale169: " +"oldInd:"+oldInd+"newInd: "+newInd);
            //checkColorAv();

               
            /*if(roombool){

            
              if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r43"){
              checkSize(newInd,4,3);
          }
        

          //console.log("HÖHE:" + (gesamthöhe) + "Breite: " + screenwidth)
          if(gesamthöhe>roomHeight.value ){
              //console.log("CLIP HEIGHT");
          } 
            if(screenwidth > roomWidth.value){
            //console.log("WIDTH HEIGHT");
          }

          //vom Boden
          if((empty.position.y-(gesamthöhe*0.01))<0){
              //console.log("CLIP CHANGE SLIDERVAL");
              empty.position.y = 0.01*(gesamthöhe+10)-2.25;
               screenheightgui(gesamthöhe+10);
     
            }
            
            // Positioniere LW immer an oberster position 
            if((empty.position.y+20>(roomHeight.value*0.01))){
              ////console.log("ZU GROß MACH KLEIN");
              empty.position.y = 0.01*(roomHeight.value-20)-2.25;
              screenheightgui(roomHeight.value-20);
        
            }
        
              checkScreensize();
          }
*/


              }


        





        

          //Gehäuse



            var varmesh = BABYLON.AbstractMesh;
          

             leinwand = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/544744329922a025/", "eZ-Cinema-TT-3DConfigurator.glb", scene, function(newMeshes){
             varmesh= newMeshes[0];
              
              gehäusemesh = scene.getTransformNodeByName("Gehäuse.001");
              leinwandmesh = scene.getTransformNodeByName("Leinwand2");
              leinwandtuch = scene.getMeshByName("Leinwand Tuch1");

              logomesh = scene.getMeshByName("LOGO.002");



             gehäusemesh.setParent(empty); 
                leinwandmesh.setParent(empty); 
                     leinwandtuch.setParent(empty); 
                  logomesh.setParent(empty); 

                empty.position.y=-2.155;
                   empty.position.z=0.2;


                //leinwandmesh.rotation = new BABYLON.Vector3(0,0,Math.PI);
                 
                  document.querySelectorAll(".buttonMat").forEach(btn => btn.addEventListener("click", changeMat));


          function changeMat(){
         //   // console.log("click");

 KonfigTracking.track('Material', selection.Material);

            BABYLON.GLTF2.Loader.Extensions.KHR_materials_variants.SelectVariant(varmesh,$(this).attr("id"));
            selection.Material=$(this).attr("id");
           

          
           
        document.querySelectorAll(".buttonMat").forEach(btn => btn.disabled = false);

        $(this).prop('disabled', true);
        
        document.querySelectorAll(".buttonMat").forEach(btn => {
  btn.style.backgroundColor = "";
  btn.style.borderColor = "";
  btn.style.borderWidth = "";
});
        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

     
           
           
            getMaterials();
           
         //   // console.log("before getsizes");
            getSizes();    
          //  // console.log("after getsizes");
        
            
     
            
         

            
      
    
          getPrice();


         //   // console.log(selection);
          }
                 
                
              
          });



              
         




       var i;


         function screenheightgui(v){


       }

    

              var slidercol = document.getElementById("sliderfiller");
        var slidercol2 = document.getElementById("sliderfiller2");

       slider2.oninput = function() {
         i = Number(slider2.value);
         sliderValue.innerHTML = i;
         
         oldInd= i;
     //   //console.log("TD VAL: "+tdVal2);
     //   //console.log("I: "+i);

          sliderWidth = this.offsetWidth;
            labelWidth = sliderValue.offsetWidth;
            newLeft = ((i - this.min) / (this.max - this.min)) * sliderWidth - (labelWidth / 2);
           ////console.log(newLeft);

           sliderValue.style.left =`${newLeft}px`;

          if(newLeft<=0){
         slidercol.style.width="10px"
                    sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

//scalefactorY*(((i*startwert) + tdVal2) / (startwert)) 62,9921






                   gehäusemesh.scaling = new BABYLON.Vector3(scalefactorX*(i/100),1,1);
          leinwandmesh.scaling = new BABYLON.Vector3 (scalefactorX*(i/100),((i*zfactor) + tdVal2) / (vfactor),1);
          leinwandtuch.scaling = new BABYLON.Vector3(scalefactorX*(i/100),1,scalefactorY*(i/100)); 
          logomesh.position = new BABYLON.Vector3(scalefactorX*((i-100)*0.0118),0,0);


          //logomesh.position = new BABYLON.Vector3(-scalefactorX*((i-100)),-0.3,0.4);

    
                leinwandmesh.rotation = new BABYLON.Vector3(0,0,0);
              
                                 gehäusemesh.rotation = new BABYLON.Vector3(Math.PI/3,0,0);

                 
 
               
              
            
                
               const nearestValue = _.minBy(values169, (value) => Math.abs(value - i));
       newInd= nearestValue;
         selection.Size = nearestValue;
        //console.log("nearesT: "+ nearestValue);

       //topDrops = Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][nearestValue];
       //console.log(topDrops);
            
       //topDrops = topDrops.map(item => Object.keys(item)[0]);
      //console.log(topDrops);
               //oldInd = i;
               //sliderValue.innerHTML = newInd;
     
               
     //scaletoTD();

     }


          slider2.addEventListener("change", () => {

           KonfigTracking.track('Size - 16:9', newInd);

                 const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        ////console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

     
         
         
     
       setTimeout(() => {
         //  setTD();
                     getPrice();

          }, "300");

                                         });
     
      
      

        const camera = new BABYLON.ArcRotateCamera("camera", -Math.PI / 2, Math.PI / 2.5, 15, new BABYLON.Vector3(0, 0, 0));
        camera.attachControl(canvas, true);
        camera.setPosition(new BABYLON.Vector3(0, -0.5,4));
        camera.target = new BABYLON.Vector3(0 ,-0.75,0);
        const light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 1, 1));

         const pointLight = new BABYLON.PointLight("point", new BABYLON.Vector3(0, 0, -5), scene);
        pointLight.intensity = 0.4;
        
      
        camera.wheelPrecision = 70;
        camera.lowerRadiusLimit=1;
        camera.minZ = 0;

       var bGchange = document.getElementById("mainelement");

        
      // Füge die Animation der Kamera hinzu
      document.getElementById("Dark").addEventListener("click",async () => {

      selection.Ambience="Dark"
KonfigTracking.track('Ambience', 'Dark');
      
        if(selection.Beamer=="Short-Throw"&&selection.Ambience=="Bright"){
         $("#Standard-Throw").css({
          "background-color": "grey",
          "cursor": "not-allowed",
      });

      $("#Standard-Throw").prop('disabled', true);
      }else{

            $("#Standard-Throw").css({
          "background-color": "white",
          "cursor": "",
      });

      $("#Standard-Throw").prop('disabled', false);
      }

              getMaterials();

console.log(avMaterials[0]);

 const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);

      
        $("#Dark").prop('disabled', true);
        $("#Bright").prop('disabled', false);

        $("#Bright").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Dark").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        //scene.clearColor = new BABYLON.Color4(0.3, 0.3, 0.3, 1);
        await sleep(10); 


        for(let i=1; i< 25; i++){
          var cVal = 100-i;
          scene.clearColor = new BABYLON.Color4(cVal/100, cVal/100, cVal/100, 1);
          bGchange.style.background = "rgb(" + cVal + "% " + cVal + "% " + cVal + "%)";

           if(roombool){
          wallMaterial.specularPower = 2.56*i;
          } 
          pointLight.intensity = 0.4-(0.016*i); 
          
          await sleep(10); 

        }

      });

            document.getElementById("Bright").addEventListener("click",async () => {

      //var buttony=  console.log(Base[selection.Beamer][selection.Ambiance][0])
 selection.Ambience="Bright"
KonfigTracking.track('Ambience', 'Bright');
        if(selection.Beamer=="Short-Throw"&&selection.Ambience=="Bright"){
         $("#Standard-Throw").css({
          "background-color": "grey",
          "cursor": "not-allowed",
      });

      $("#Standard-Throw").prop('disabled', true);
      }else{

            $("#Standard-Throw").css({
          "background-color": "white",
          "cursor": "",
      });

      $("#Standard-Throw").prop('disabled', false);
      }




     
              getMaterials();

              console.log(avMaterials[0]);
        const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);

        $("#Bright").prop('disabled', true);
        $("#Dark").prop('disabled', false);


        $("#Dark").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Bright").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        

        //scene.clearColor = new BABYLON.Color4(0.3, 0.3, 0.3, 1);
        await sleep(10); 


        for(let i=1; i< 25; i++){
          var cVal2 = 75+i
          scene.clearColor = new BABYLON.Color4(cVal2/100, cVal2/100, cVal2/100, 1);         
          bGchange.style.background = "rgb(" + cVal2 + "% " + cVal2 + "% " + cVal2 + "%)";
          if(roombool){
            wallMaterial.specularPower = 64-(2.56*i);
                    }
          pointLight.intensity = 0.016*i;
          await sleep(10); 

        }

      });

    
     
     /* document.getElementById("removebeamer").addEventListener("click",removeB);

      function removeB(){
        camera.setPosition(new BABYLON.Vector3(0, -1,4));
        camera.target = new BABYLON.Vector3(0 ,-0.5,0);
        if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        shortbeambool = false;
        }else if(standardbeambool){
          if(standardbeambool){
            stbeamermesh.dispose();
          stbeammesh.dispose();
          standarbeambool = false;
          }
        }
      } */

        //Beamer
   
      
     

    



      //ROOMSTART

        //getSizes();
  //ROOM
const buttons = [ "CLR","Cinegrey"];

          var mainWall; 
    var roombool;
         var wallMaterial;

    function createRoom(){
         $('#roomgui').toggleClass('panel');
          $('#roomgui').removeClass('roomguic');
 document.getElementById("createRoom").style.display="none";
      KonfigTracking.track('Room', 'start');
      roombool=true;
      if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
         else if(selection.Aspect==="r43"){
              checkSize(newInd,4,3);
          }
        
          

        wallMaterial = new BABYLON.StandardMaterial("wallMat", scene);
        wallMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
        wallMaterial.roughness=0;
        wallMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1); // weniger Glanz
        
      if(selection.Ambience=="Dark"){wallMaterial.specularPower = 64;}else{
        wallMaterial.specularPower = 0;
      } // glatterer Glanzpunkt

        const floorMaterial = new BABYLON.StandardMaterial("floorMat", scene);
        var  texture = new BABYLON.Texture("https://cdn.shopify.com/s/files/1/0568/2806/8035/files/floor.webp?v=1752150856", scene);

        floorMaterial.diffuseTexture =  texture;
        //floorMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);

      

        // Maße
        var wallWidth = 0.01*(screenwidth+100);
        //console.log(wallWidth);
        var wallHeight = 2.45;
        var wallDepth = 0.01;


        // Setze interface mit beschränkungen
          roomHeight.value=245;
          roomWidth.value=parseInt(screenwidth)+100;
        //

        var floorWidth = wallWidth;
        var floorLength = wallWidth + wallDepth;
        // Hauptwand (Front)
         mainWall = BABYLON.MeshBuilder.CreateBox("mainWall", {
            width: 1,
            height: 1,
            depth: 0.01
        }, scene);
        //mainWall.position = new BABYLON.Vector3(0, -3, 0);
        mainWall.material = wallMaterial;
        mainWall.setPivotPoint(new BABYLON.Vector3(0, -1 / 2, 0));

        // Linke Wand
        const leftWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);

        leftWall.rotation.y = 1.5*Math.PI;
        // position x = -halbe Wandbreite, z = -halbe Wandbreite (links hinten)
        leftWall.position = new BABYLON.Vector3(-1 / 2, 0, -1 / 2);
        leftWall.material = wallMaterial;

        // Rechte Wand
        const rightWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        rightWall.rotation.y = Math.PI / 2;
        // position x = +halbe Wandbreite, z = -halbe Wandbreite (rechts hinten)
        rightWall.position = new BABYLON.Vector3(1 / 2, 0, -1 / 2);
        rightWall.material = wallMaterial;

        // Boden als Plane genau passend in den Raum
        // Breite = wallWidth (zwischen linken und rechten Wand-Innenkanten)
        // Länge = wallWidth + Wanddicke (von Frontwand bis Rückseite der Seitenwände)
        // etwas tiefer als Seitenwand Tiefe

        const floor = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        floor.rotation.x = Math.PI / 2; // flach auf Boden
        // positioniert unterhalb der Wände:
        // Y = 0 (Boden)
        // Z = -(floorLength / 2) + Wanddicke/2 (damit es unter Frontwand und zwischen Seitenwänden liegt)
        floor.position = new BABYLON.Vector3(0, -1/2, -1.01 / 2 + 0.01 / 2);
        floor.material = floorMaterial;

        // Parenting
        leftWall.parent = mainWall;
        rightWall.parent = mainWall;
        floor.parent = mainWall;

        
        mainWall.rotation.y=Math.PI;
        mainWall.position.y=-1.75;
        mainWall.position.z=-0.065;

        mainWall.scaling.x=wallWidth;
        mainWall.scaling.y=wallHeight;
         mainWall.scaling.z=3;
          

//empty.position.y = 0.25;

        /*
            if((empty.position.y-(gesamthöhe*0.01))<0){
              //console.log("CLIP");
              empty.position.y = 0.01*(gesamthöhe+10)-2.25;
              screenheightgui(gesamthöhe+10);
            }*/
          

     }
    
    

//createRoom();
        //Skaliere Raum:
        //console.log("TEST");
        document.getElementById("createRoom").addEventListener("click",createRoom);
    //WAND ENDE


    document.getElementById("removeRoom").addEventListener("click",deleteRoom);

    function deleteRoom(){
      KonfigTracking.track('Room', 'end');
       roombool=false; 
          mainWall.dispose();
           $('#roomgui').removeClass('panel');
          $('#roomgui').toggleClass('roomguic');
       document.getElementById("createRoom").style.display="flex";
    }

    document.getElementById("updateRoom").addEventListener("click",updateRoom );

      
     const roomHeight = document.getElementById("roomheight");
  const roomWidth = document.getElementById("roomwidth");

    function updateRoom(){
       
  const roomHeightval =roomHeight.value;
  const roomWidthval = roomWidth.value

      //console.log(roomWidthval/screenwidth+100);
          //mainWall.scaling.y = (0.01*roomHeightval)/2.4
 if (
  !isNaN(roomHeightval)
 && roomHeightval >= 220 && roomHeightval <= 600 
 
) {
  mainWall.scaling.y = roomHeightval/100; // 300 = 0.8 || 245 = 0.25 || 220 = 0
  //console.log("Raumhöhe:", roomHeightval, "cm");
  //empty.position.y= (((roomHeightval-220))* 0.00994);

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 //console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

    

 if((parseInt(empty.position.y*100))>roomHeightval){
  
 }else{
 
//screenheightgui(parseInt((empty.position.y+2.25)*100));
 }
  
}else{
    //console.log("Please enter a wall height between 220 cm and 600 cm");

  alert("Please enter a wall height between 220 cm and 600 cm");

}

 if(!isNaN(roomWidthval) &&  roomWidthval >= 240 && roomWidthval <= 1000){
  mainWall.scaling.x = roomWidthval/100;
  //console.log("Raumhöhe:", roomHeightval, "cm");

 

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 //console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

  /*    if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
         else if(selection.Aspect==="r43"){
              checkSize(newInd,4,3);
          }
*/
 if((parseInt(empty.position.y*100))>roomHeightval){
  //console.log("clipeprcheck");
  

 }else{
 
//screenheightgui(parseInt((empty.position.y+2.25)*100));
 }

 }else{ 
  //console.log("Please enter a wall width between 240 cm and 1000 cm");
  alert("Please enter a wall width between 240 cm and 1000 cm");}

 
//checkScreensize();
 
    }

    var gesamthöhe;
    var screenwidth;

      function checkSize(diagonalInInches, ratioWidth, ratioHeight){

        //console.log("TD: "+nearestTopDrop + "NewInd"+newInd);

        var factor = Math.sqrt(ratioWidth ** 2 + ratioHeight ** 2);

        


        //var widthInInches = diagonalInInches * (ratioWidth / factor);
        var heightInInches = diagonalInInches * (ratioHeight / factor);

        screenwidth = 264* (diagonalInInches/100);
        var screenheight = heightInInches * 2.54;

         gesamthöhe = parseInt(screenheight + 6 + Number(nearestTopDrop) + 10);
        //console.log("Berechnung: height"+ screenheight + "neearest TD: "+ nearestTopDrop);

 
      

        //wenn wir ein kleineres tD größer machen, dann muss es auf das neue min springen automatisch
        // -> if 

        //console.log("Breite: "+ screenwidth);
        //console.log("Höhe: "+ gesamthöhe );



      }

      //document.getElementById("checksizing").addEventListener("click",checkSize(newInd,16,9));

      
      function checkScreensize(){
//console.log("SCREENSIZE"),
////console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
// //console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
roomnotice.style.display="none";


if(gesamthöhe+20>roomHeight.value){
  //console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
  roomnotice.style.display="flex";
}

if(screenwidth>roomWidth.value){
 //console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
  roomnotice.style.display="flex";
}
      }


         // ROOMEND

         //scene.debugLayer.show();
    
   
        return scene;
      };

      
    
      function startRender(){
      const scene = createScene(); //Call the createScene function
      scene.clearColor = new BABYLON.Color4(0.75, 0.75, 0.75, 1);
      //engine.resize();

      // Register a render loop to repeatedly render the scene
      engine.runRenderLoop(function () {
        scene.render();
      });

      // Watch for browser/canvas resize events
      window.addEventListener("resize", function () {
        engine.resize();
      })
    }

var butAddC = document.getElementById("addCart");
      
            function checkVariantAvailability(variantId) {
  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(variant => {
      if (variant.available) {
        //console.log('Variante verfügbar ✅');
        butAddC.innerHTML="Add to cart"
        butAddC.classList.remove('disabled');
        butAddC.disabled=false;
        // Hier Button aktivieren
        //document.querySelector('#add-to-cart-button').disabled = false;
      } else {
        //console.log('Variante NICHT verfügbar ❌');
        butAddC.innerHTML="Sold out"
       butAddC.disabled=true;
        butAddC.classList.add('disabled');
        // Hier Button deaktivieren
        //document.querySelector('#add-to-cart-button').disabled = true;
      }
    })
    .catch(err => {
      console.error('Fehler beim Prüfen der Variante:', err);
    });
}


  //startRender();
    

      //startRender();
    

      document.getElementById("canvas-style").addEventListener("click", startEngine, { once: true })
  document.getElementById("canvas-style").addEventListener("touchstart",startEngine, { once: true });
    
  function startEngine(){
document.getElementById("poster").style.display="none";
  }

  var  formData ={
  'items': [ {
    'id': 50531704307978,
    'quantity': 1
     
    } ]
};
document.getElementById("addCart").addEventListener("click", addItems1);


function addItems1() {
    //console.log("additem " + selection.ProdVariant );
  formData.items[0].id=selection.ProdVariant;
    //console.log("formData: "+ JSON.stringify(formData, null, 2))
  KonfigTracking.track('addcart', 'addcart', (price/100).toFixed(2));

// fügt in den Cart JS hinzu
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },



  
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});

  

  console.log("Added");

 
setTimeout(() => {
    window.location.href = window.location.origin + '/cart';
}, "1000");



}